// import React, { useState } from "react";
// import "../assets/UpdatePassword.css";
// import { useDispatch } from "react-redux";
// import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { MdLock, MdKey } from "react-icons/md";

// const UpdatePassword = () => {
//   const dispatch = useDispatch();

//   const [filterType, setFilterType] = useState("Employee id");
//   const [filterValue, setFilterValue] = useState("");
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     oldPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//     oldPin: "",
//     newPin: "",
//     confirmPin: ""
//   });

//   const superAdminId = localStorage.getItem("adminuserId") || "12";

//   // 🔍 Search Employee
//   const handleSearch = async () => {
//     if (!filterValue?.trim()) {
//       return toast.warn("Please enter a value to search.");
//     }

//     let query = { superAdminId };

//     switch (filterType) {
//       case "Employee id":
//         query.userId = filterValue.trim();
//         break;
//       case "pan":
//         query.panNumber = filterValue.trim();
//         break;
//       case "aadhaar":
//         query.aadhaarNumber = filterValue.trim();
//         break;
//       case "mobile":
//         query.mobileNumber = filterValue.trim();
//         break;
//       default:
//         return toast.warn("Unsupported filter type.");
//     }

//     try {
//       setLoading(true);
//       const response = await axios.get("https://narrowitsolution.in/api/get-employ-filter", {
//         params: query
//       });

//       if (response.data?.status === false || !response.data?.data) {
//         setSelectedEmployee(null);
//         return toast.info(response.data?.message || "Employee not found.");
//       }

//       const emp = response.data.data;

//       setSelectedEmployee({
//         userId: emp.userId,
//         name: emp.fullName,
//         pan: emp.panNumber,
//         aadhaar: emp.aadhaarNumber,
//         mobile: emp.mobileNumber,
//         dob: emp.dateOfBirth?.slice(0, 10)
//       });

//       // dispatch redux fetch if needed
//       dispatch(fetchEmployeeReport({ page: 1, userId: emp.userId }));
//     } catch (err) {
//       console.error(err);
//       setSelectedEmployee(null);
//       toast.error("Failed to fetch employee. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 📝 Input Change
//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // 📌 Submit Update
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!selectedEmployee) {
//       toast.error("Please search and select an employee first!");
//       return;
//     }

//     const { oldPassword, newPassword, confirmPassword, oldPin, newPin, confirmPin } = formData;

//     if (newPassword && newPassword !== confirmPassword) {
//       return toast.error("New Password and Confirm Password do not match!");
//     }
//     if (newPin && newPin !== confirmPin) {
//       return toast.error("New PIN and Confirm PIN do not match!");
//     }

//     try {
//       // 🔹 Update Password
//       if (oldPassword && newPassword && confirmPassword) {
//         await axios.put("https://narrowitsolution.in/api/employee/update-password", {
//           userId: selectedEmployee.userId,
//           oldPassword,
//           newPassword,
//           confirmPassword
//         });
//         toast.success("Password updated successfully!");
//       }

//       // 🔹 Update PIN
//       if (oldPin && newPin && confirmPin) {
//         await axios.put("https://narrowitsolution.in/api/employee/update-pin", {
//           userId: selectedEmployee.userId,
//           oldPin,
//           newPin,
//           confirmPin
//         });
//         toast.success("PIN updated successfully!");
//       }

//       setFormData({
//         oldPassword: "",
//         newPassword: "",
//         confirmPassword: "",
//         oldPin: "",
//         newPin: "",
//         confirmPin: ""
//       });
//     } catch (err) {
//       console.error(err);
//       toast.error(err.response?.data?.message || "Failed to update credentials.");
//     }
//   };

//   return (
//     <div className="UpdatePassword-container">
//       <div className="UpdatePassword-form">
//         <h2 className="UpdatePassword-title">
//           <MdLock /> Reset Employee Password & PIN
//         </h2>

//         {/* Search Employee */}
//         <section>
//           <h2>Search Employee</h2>
//           <div className="search-controls">
//             <select
//               value={filterType}
//               onChange={(e) => {
//                 setFilterType(e.target.value);
//                 setFilterValue("");
//               }}
//             >
//               <option value="">Select Filter</option>
//               <option value="Employee id">Employee ID</option>
//               <option value="pan">PAN</option>
//               <option value="aadhaar">Aadhaar</option>
//               <option value="mobile">Mobile</option>
//             </select>
//             <input
//               type="text"
//               placeholder={`Enter ${filterType || "value"}`}
//               value={filterValue}
//               onChange={(e) => setFilterValue(e.target.value)}
//             />
//             <button onClick={handleSearch} disabled={loading}>
//               {loading ? "Searching..." : "Search"}
//             </button>
//           </div>
//         </section>

//         {/* Employee Details */}
//         {selectedEmployee && (
//           <div className="kyc-table-employe">
//             <section>
//               <h2>Employee Details</h2>
//               <table>
//                 <tbody>
//                   <tr>
//                     <th>User ID</th>
//                     <td>{selectedEmployee?.userId}</td>
//                   </tr>
//                   <tr>
//                     <th>Name</th>
//                     <td>{selectedEmployee?.name}</td>
//                   </tr>
//                   <tr>
//                     <th>PAN</th>
//                     <td>{selectedEmployee?.pan}</td>
//                   </tr>
//                   <tr>
//                     <th>Aadhaar</th>
//                     <td>{selectedEmployee?.aadhaar}</td>
//                   </tr>
//                   <tr>
//                     <th>Mobile</th>
//                     <td>{selectedEmployee?.mobile}</td>
//                   </tr>
//                   <tr>
//                     <th>DOB</th>
//                     <td>{selectedEmployee?.dob}</td>
//                   </tr>
//                 </tbody>
//               </table>
//             </section>
//           </div>
//         )}

//         {/* Update Form */}
//         <form onSubmit={handleSubmit}>
//           <div className="UpdatePassword-columns">
//             {/* Password Section */}
//             <div className="UpdatePassword-section">
//               <h4 className="UpdatePassword-subheading">
//                 <MdLock /> Password
//               </h4>
//               <div className="UpdatePassword-field">
//                 <label>Old Password</label>
//                 <input
//                   type="password"
//                   name="oldPassword"
//                   value={formData.oldPassword}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="UpdatePassword-field">
//                 <label>New Password</label>
//                 <input
//                   type="password"
//                   name="newPassword"
//                   value={formData.newPassword}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="UpdatePassword-field">
//                 <label>Confirm Password</label>
//                 <input
//                   type="password"
//                   name="confirmPassword"
//                   value={formData.confirmPassword}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             {/* PIN Section */}
//             <div className="UpdatePassword-section">
//               <h4 className="UpdatePassword-subheading">
//                 <MdKey /> PIN
//               </h4>
//               <div className="UpdatePassword-field">
//                 <label>Old PIN</label>
//                 <input
//                   type="password"
//                   name="oldPin"
//                   maxLength="6"
//                   value={formData.oldPin}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="UpdatePassword-field">
//                 <label>New PIN</label>
//                 <input
//                   type="password"
//                   name="newPin"
//                   maxLength="6"
//                   value={formData.newPin}
//                   onChange={handleChange}
//                 />
//               </div>
//               <div className="UpdatePassword-field">
//                 <label>Confirm PIN</label>
//                 <input
//                   type="password"
//                   name="confirmPin"
//                   maxLength="6"
//                   value={formData.confirmPin}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>
//           </div>

//           <button type="submit" className="UpdatePassword-button">
//             <MdLock /> Update Credentials
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default UpdatePassword;
import React, { useState } from "react";
import "../assets/UpdatePassword.css";
import { useDispatch } from "react-redux";
import { fetchEmployeeReport } from "../redux/slices/employeeReportSlice";
import axios from "axios";
import { toast } from "react-toastify";
import { MdLock, MdKey } from "react-icons/md";

const UpdatePassword = () => {
  const dispatch = useDispatch();

  const [filterType, setFilterType] = useState("Employee id");
  const [filterValue, setFilterValue] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    oldPin: "",
    newPin: "",
    confirmPin: ""
  });

  const superAdminId = localStorage.getItem("adminuserId") || "12";

  // 🔍 Search Employee
  const handleSearch = async () => {
    if (!filterValue?.trim()) {
      return toast.warn("Please enter a value to search.");
    }

    let query = { superAdminId };

    switch (filterType) {
      case "Employee id":
        query.userId = filterValue.trim();
        break;
      case "pan":
        query.panNumber = filterValue.trim();
        break;
      case "aadhaar":
        query.aadhaarNumber = filterValue.trim();
        break;
      case "mobile":
        query.mobileNumber = filterValue.trim();
        break;
      default:
        return toast.warn("Unsupported filter type.");
    }

    try {
      setLoading(true);
      const response = await axios.get("https://narrowitsolution.in/api/get-employ-filter", {
        params: query,
      });

      if (response.data?.status === false || !response.data?.data) {
        setSelectedEmployee(null);
        return toast.info(response.data?.message || "Employee not found.");
      }

      const emp = response.data.data;

      setSelectedEmployee({
        id:emp.id,
        userId: emp.userId,
        name: emp.fullName,
        pan: emp.panNumber,
        aadhaar: emp.aadhaarNumber,
        mobile: emp.mobileNumber,
        dob: emp.dateOfBirth?.slice(0, 10),
      });

      // fetch employee details
      dispatch(fetchEmployeeReport({ page: 1, userId: emp.userId }));
    } catch (err) {
      console.error(err);
      setSelectedEmployee(null);
      toast.error("Failed to fetch employee. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // 📝 Input Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 📌 Update Password
  const handleUpdatePassword = async () => {
    if (!selectedEmployee) return toast.error("Please search and select an employee first!");

    const { oldPassword, newPassword, confirmPassword } = formData;
    if (!oldPassword || !newPassword || !confirmPassword) {
      return toast.error("Please fill all password fields.");
    }
    if (newPassword !== confirmPassword) {
      return toast.error("New Password and Confirm Password do not match!");
    }

    try {
      await axios.post(
        `https://narrowitsolution.in/api/update-password-employee/${selectedEmployee.id}`,
        { oldPassword, newPassword, confirmPassword }
      );
      toast.success("Password updated successfully!");
      setFormData({ ...formData, oldPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to update password.");
    }
  };

  // 📌 Update PIN
  const handleUpdatePin = async () => {
    if (!selectedEmployee) return toast.error("Please search and select an employee first!");

    const { oldPin, newPin, confirmPin } = formData;
    if (!oldPin || !newPin || !confirmPin) {
      return toast.error("Please fill all PIN fields.");
    }
    if (newPin !== confirmPin) {
      return toast.error("New PIN and Confirm PIN do not match!");
    }

    try {
      await axios.post(
        `https://narrowitsolution.in/api/update-pin-employee/${selectedEmployee.id}`,
        { oldPin, newPin, confirmPin }
      );
      toast.success("PIN updated successfully!");
      setFormData({ ...formData, oldPin: "", newPin: "", confirmPin: "" });
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to update PIN.");
    }
  };

  return (
    <div className="UpdatePassword-container">
      <div className="UpdatePassword-form">
        <h2 className="UpdatePassword-title">
          <MdLock /> Reset Employee Password & PIN
        </h2>

        {/* Search Employee */}
        <section>
          <h2>Search Employee</h2>
          <div className="search-controls">
            <select
              value={filterType}
              onChange={(e) => {
                setFilterType(e.target.value);
                setFilterValue("");
              }}
            >
              <option value="">Select Filter</option>
              <option value="Employee id">Employee ID</option>
              <option value="pan">PAN</option>
              <option value="aadhaar">Aadhaar</option>
              <option value="mobile">Mobile</option>
            </select>
            <input
              type="text"
              placeholder={`Enter ${filterType || "value"}`}
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
            />
            <button onClick={handleSearch} disabled={loading}>
              {loading ? "Searching..." : "Search"}
            </button>
          </div>
        </section>

        {/* Employee Details */}
        {selectedEmployee && (
          <div className="kyc-table-employe">
            <section>
              <h2>Employee Details</h2>
              <table>
                <tbody>
                  <tr><th>User ID</th><td>{selectedEmployee?.userId}</td></tr>
                  <tr><th>Name</th><td>{selectedEmployee?.name}</td></tr>
                  <tr><th>PAN</th><td>{selectedEmployee?.pan}</td></tr>
                  <tr><th>Aadhaar</th><td>{selectedEmployee?.aadhaar}</td></tr>
                  <tr><th>Mobile</th><td>{selectedEmployee?.mobile}</td></tr>
                  <tr><th>DOB</th><td>{selectedEmployee?.dob}</td></tr>
                </tbody>
              </table>
            </section>
          </div>
        )}

        {/* Update Form */}
        <div className="UpdatePassword-columns">
          {/* Password Section */}
          <div className="UpdatePassword-section">
            <h4 className="UpdatePassword-subheading">
              <MdLock /> Password
            </h4>
            <div className="UpdatePassword-field">
              <label>Old Password</label>
              <input
                type="password"
                name="oldPassword"
                value={formData.oldPassword}
                onChange={handleChange}
              />
            </div>
            <div className="UpdatePassword-field">
              <label>New Password</label>
              <input
                type="password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
              />
            </div>
            <div className="UpdatePassword-field">
              <label>Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
            </div>
            <button
              type="button"
              className="UpdatePassword-button"
              onClick={handleUpdatePassword}
            >
              <MdLock /> Update Password
            </button>
          </div>

          {/* PIN Section */}
          <div className="UpdatePassword-section">
            <h4 className="UpdatePassword-subheading">
              <MdKey /> PIN
            </h4>
            <div className="UpdatePassword-field">
              <label>Old PIN</label>
              <input
                type="password"
                name="oldPin"
                maxLength="6"
                value={formData.oldPin}
                onChange={handleChange}
              />
            </div>
            <div className="UpdatePassword-field">
              <label>New PIN</label>
              <input
                type="password"
                name="newPin"
                maxLength="6"
                value={formData.newPin}
                onChange={handleChange}
              />
            </div>
            <div className="UpdatePassword-field">
              <label>Confirm PIN</label>
              <input
                type="password"
                name="confirmPin"
                maxLength="6"
                value={formData.confirmPin}
                onChange={handleChange}
              />
            </div>
            <button
              type="button"
              className="UpdatePassword-button"
              onClick={handleUpdatePin}
            >
              <MdKey /> Update PIN
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
